/* AQUON Ingredient Cards 2 - premium 3D flip.
   Front image card flips to a frosted detail back. Cards flip independently.
   Accessible: real buttons, aria-expanded, inert on the hidden face, Escape to
   close, focus moves to the back and returns to the front. Minimal, no deps. */
(function () {
  'use strict';

  // On mouse / desktop / webview the flip is driven by CSS :hover; only touch
  // devices (no hover) use tap-to-flip wired here.
  var hoverFlip = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function initCard(card) {
    if (hoverFlip) return;
    var front = card.querySelector('[data-aic2-front]');
    var back = card.querySelector('[data-aic2-back]');
    var close = card.querySelector('[data-aic2-close]');
    if (!front || !back) return;

    function setFace(flipped) {
      card.classList.toggle('is-flipped', flipped);
      front.setAttribute('aria-expanded', flipped ? 'true' : 'false');
      back.setAttribute('aria-hidden', flipped ? 'false' : 'true');
      // keep the hidden face out of tab order / pointer
      try { back.inert = !flipped; front.inert = flipped; } catch (e) {}
    }

    function open() {
      setFace(true);
      // focus the close control on the now-visible back
      if (close) { try { close.focus({ preventScroll: true }); } catch (e) { close.focus(); } }
    }
    function shut() {
      setFace(false);
      try { front.focus({ preventScroll: true }); } catch (e) { front.focus(); }
    }

    // initial state
    setFace(false);

    front.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && card.classList.contains('is-flipped')) { e.stopPropagation(); shut(); }
    });
  }

  function initRoot(root) {
    root.querySelectorAll('[data-aic2-card]').forEach(initCard);
  }
  function initAll() { document.querySelectorAll('[data-aic2-root]').forEach(initRoot); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-aic2-root]');
    if (r) initRoot(r);
  });
})();
